<!-- <div class="topDiv" id="topContentDiv" [style.background-color]="backgroundColorScreen"
  style="padding: 5px;">
  <div class="agGridOuterDiv">
    <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 30px;
          ">
          <label i18n="@@spmsUserReg" class="textColour">Signal Managment</label>
          <span class="example-spacer"></span>
            <nav mat-tab-nav-bar mat-stretch-tabs>
            <a
              mat-tab-link
              *ngFor="let link of navLinks"
             
              [active]="link.label === 'Stage Objects'"
              style="min-width: fit-content;opacity: 1;"
              rel="noopener"
            >
              {{ link.label }}
            </a>
          </nav>
        </div>

      </div>
  </div> -->

        <div style="    height: 5.5%;
    width: 100%;
    background: #f8f8f8;
    position: absolute;
    z-index: 100;
    margin-top: 3.57%;">
 <div class="toolbar-scroll" #toolbarScroll (scroll)="onScroll()">
 <button mat-icon-button [matMenuTriggerFor]="appsMenu" style="width: fit-content;
    height: fit-content;
    border-radius: unset;
    margin-right: 10px;margin-left: 10px;">
  <mat-icon style="font-size: 25px;">apps</mat-icon>
  <span style="    margin-left: 2px;
    font-size: 1rem;
    color: #1d1d1d;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: normal;">{{selectedTopNavItem.label}}</span>
</button>
<div role="separator" class="tabcollection-separator" style="border-right: 2px solid #ccc;
    height: 20px;
    margin-right: 10px;"></div>
<!-- <p>{{selectedTopNavItem.label}}</p> -->
<mat-menu #appsMenu="matMenu" class="apps-menu-panel">
  <ul class="apps-list">
    <li *ngFor="let item of topNavItems" (click)="selectTopNavItem(item)">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </li>
  </ul>
</mat-menu>
          <ng-container *ngFor="let subItem of (selectedTopNavItem?.subToolbarItems || [])">
             <button
                mat-button
                class="nav-item"
                [ngClass]="{ active: currentSection === subItem.section }"
                (click)="handleNavClick(subItem)"
              >
                <mat-icon>{{ subItem.icon }}</mat-icon>
                <span>{{ subItem.label }}</span>
              </button>
          </ng-container>
        </div>
        </div>

<!-- SIDEBAR HOVER WRAPPER -->
<!-- Hover area only when sidenav is collapsed -->
<div class="collapsed-sidebar-hover" *ngIf="!isSidenavOpen">
  <div class="hover-toggle">
    <button
      mat-icon-button
      class="toggle-btn"
      [style.background-color]="backgroundColorButton"
      (click)="toggleSidenav()"
      aria-label="Expand Sidebar"
      matTooltip="Expand Sidebar"
      matTooltipPosition="right"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
<div class="topDiv" style="margin-top:5%">
        <div class="embedded-container">
          <!-- add new screen here <app-dummy *ngIf="currentSection === 'other-screen'"></app-dummy> -->

          <app-jsignal *ngIf="currentSection === 'jsignal'"></app-jsignal>
          <!-- PRODUCT INFO SECTION -->
          <app-product-info
            *ngIf="currentSection === 'product-info'"
          ></app-product-info>

          <!-- SEARCH  SECTION -->
          <div
            *ngIf="currentSection === 'search-info'"
            class="search-overlay"
            style="padding: 1rem"
          >
            <h3 style="margin-bottom: 1rem">Search Filters</h3>

            <form
              [formGroup]="searchForm"
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1rem;
                max-width: 800px;
              "
            >
              <!-- Dynamic form fields -->
              <ng-container *ngFor="let field of schema; trackBy: trackByKey">
                <ng-container [ngSwitch]="field.type">
                  <!-- Text Input -->
                  <mat-form-field *ngSwitchCase="'text'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput [formControlName]="field.key" />
                  </mat-form-field>

                  <!-- Select -->
                  <mat-form-field *ngSwitchCase="'select'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-select [formControlName]="field.key">
                      <mat-option
                        *ngFor="let opt of field.options"
                        [value]="opt"
                        >{{ opt }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>

                  <!-- Multiselect -->
                  <mat-form-field
                    *ngSwitchCase="'multiselect'"
                    appearance="outline"
                  >
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-select multiple [formControlName]="field.key">
                      <mat-option
                        *ngFor="let opt of field.options"
                        [value]="opt"
                        >{{ opt }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>

                  <!-- Date -->

                  <mat-form-field *ngSwitchCase="'date'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>

                    <input
                      matInput
                      [formControlName]="field.key"
                      [matDatepicker]="picker"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </ng-container>
            </form>

            <!-- Buttons -->
            <div style="margin-top: 1rem; display: flex; gap: 1rem">
              <button
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="backgroundColorButton"
                (click)="applyFilters()"
              >
                Apply Filters
              </button>
              <button
                style="width: 70px; margin-left: 10px"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="backgroundColorButton"
                title="Cancel"
                (click)="closeSearch()"
              >
                Cancel
              </button>
            </div>
          </div>

          <app-product-safety-strategy
            *ngIf="currentSection === 'Product Safety Strategy'"
          ></app-product-safety-strategy>
          <app-create-template
            *ngIf="currentSection === 'Product Safety Strategy Template'"
          >
          </app-create-template>
          <app-review-approve *ngIf="currentSection === 'Review & Approve'">
          </app-review-approve>
          <app-review-activities *ngIf="currentSection === 'review-info'">
          </app-review-activities>
          <app-meddra-browser *ngIf="currentSection === 'MedDRA-info'">
          </app-meddra-browser>

          <!-- USER MANAGEMENT SECTION -->
          <div class="content" *ngIf="currentSection === 'user-management'">
            <h3>User Account Information</h3>
            <div class="form-grid">
              <mat-label>User ID:</mat-label>
              <input matInput value="SM_USER_1234" readonly />

              <mat-label>User Name:</mat-label>
              <input matInput value="Company Specific User Name" readonly />

              <mat-label>First Name:</mat-label>
              <input matInput value="Jon" readonly />

              <mat-label>Last Name:</mat-label>
              <input matInput value="Smith" readonly />

              <mat-label>Email ID:</mat-label>
              <input matInput value="abc@xyz.com" readonly />

              <mat-label>Roles:</mat-label>
              <mat-form-field appearance="fill">
                <mat-select multiple>
                  <mat-option selected>Admin</mat-option>
                  <mat-option>User</mat-option>
                  <mat-option>Manager</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Add remaining user info fields similarly -->
            </div>
          </div>
        </div>
      </div>
<mat-sidenav-container
  autosize
  class="sidenav-container"
  style="margin-top: 4%"
  [style.background-color]="backgroundColorScreen"
  *ngIf="false"
>
  <!-- Sidebar -->
  <mat-sidenav
    #sidenav
    mode="side"
    [(opened)]="isSidenavOpen"
    class="sidebar"
    [fixedInViewport]="true"
    [style.width.px]="sidenavWidth"
    [ngClass]="{ closed: !isSidenavOpen }"
  >
    <div class="sidebar-header">
      <!-- Collapse button -->
      <button
        mat-icon-button
        class="toggle-btn"
        [style.background-color]="backgroundColorButton"
        (click)="toggleSidenav()"
        aria-label="Collapse Sidebar"
        matTooltip="Collapse Sidebar"
        matTooltipPosition="right"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>

    <!-- Sidebar Container -->
    <div style="display: flex; flex-direction: column; gap: 1rem">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Product</mat-label>
        <mat-select
          [(value)]="selectedProduct"
          (selectionChange)="onProductSelected($event.value)"
        >
          <!-- Search input inside dropdown -->
          <mat-option>
            <input
              matInput
              placeholder="Search products..."
              [(ngModel)]="productSearchText"
              (ngModelChange)="filterProducts()"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              autofocus
            />
          </mat-option>

          <!-- Filtered product options -->
          <ng-container *ngIf="productsDisplayed.length > 0; else noProducts">
            <mat-option
              *ngFor="let product of productsDisplayed"
              [value]="product"
            >
              {{ product.name }}
            </mat-option>
          </ng-container>

          <ng-template #noProducts>
            <mat-option disabled>No product found</mat-option>
          </ng-template>

          <ng-template #noProducts>
            <mat-option disabled>No product found</mat-option>
          </ng-template>
        </mat-select>
      </mat-form-field>

      <!-- Collapsible Filter Section -->

      <mat-expansion-panel [expanded]="activeFilters.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title> Filters </mat-panel-title>
          <mat-panel-description>
            <span
              *ngIf="activeFilters.length > 0"
              style="font-size: 12px; color: #888"
              >{{ activeFilters.length }} active</span
            >
            <span
              *ngIf="activeFilters.length === 0"
              style="font-size: 12px; color: #888"
              >None applied</span
            >
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Active Filter Chips -->
        <div
          *ngIf="activeFilters.length > 0"
          style="display: flex; flex-direction: column; gap: 0.5rem"
        >
          <div
            *ngFor="let filter of activeFilters"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              background-color: #f1f1f1;
              padding: 6px 12px;
              border-radius: 12px;
              min-height: 32px;
              gap: 1rem;
              flex-wrap: nowrap;
            "
          >
            <div style="font-size: 13px; display: flex; flex-direction: column">
              <strong>{{ filter.label }}:</strong>
              <ng-container *ngIf="isArray(filter.value); else singleVal">
                <span style="white-space: pre-wrap; word-break: break-word">{{
                  filter.value.join(", ")
                }}</span>
              </ng-container>
              <ng-template #singleVal>
                <span style="white-space: pre-wrap; word-break: break-word">{{
                  filter.value
                }}</span>
              </ng-template>
            </div>
            <button
              mat-icon-button
              color="warn"
              (click)="removeFilter(filter)"
              style="height: 24px; width: 24px; min-width: 24px"
            >
              <mat-icon style="font-size: 18px">close</mat-icon>
            </button>
          </div>

          <!-- Clear All -->
          <button
            class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            (click)="clearAllFilters()"
            style="
              align-self: flex-start;
              margin-top: 0.5rem;
              font-size: 12px;
              padding: 2px 12px;
            "
          >
            Clear All
          </button>
        </div>

        <!-- No filters fallback -->
        <div
          *ngIf="activeFilters.length === 0"
          style="font-size: 12px; color: #888; padding-top: 0.5rem"
        >
          No filters applied.
        </div>
      </mat-expansion-panel>

      <!-- Advance Filter  -->

      <mat-expansion-panel [expanded]="advancedSchema.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title>Advanced Filters</mat-panel-title>
          <mat-panel-description>
            <span
              *ngIf="advancedSchema.length > 0"
              style="font-size: 12px; color: #888"
            >
              {{ advancedSchema.length }} active
            </span>
            <span
              *ngIf="advancedSchema.length === 0"
              style="font-size: 12px; color: #888"
            >
              None applied
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Scrollable Content Area -->
        <div style="overflow: visible">
          <!-- Field Picker -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Add Field</mat-label>
            <mat-select (selectionChange)="addAdvancedField($event.value)">
              <mat-optgroup label="Product Info">
                <mat-option
                  *ngFor="let f of allPossibleFields.slice(0, 4)"
                  [value]="f"
                  [disabled]="getAdvancedFieldByKey(f.key)"
                >
                  {{ f.label }}
                </mat-option>
              </mat-optgroup>

              <mat-optgroup label="Therapy Info">
                <mat-option
                  *ngFor="let f of allPossibleFields.slice(4, 10)"
                  [value]="f"
                  [disabled]="getAdvancedFieldByKey(f.key)"
                >
                  {{ f.label }}
                </mat-option>
              </mat-optgroup>

              <mat-optgroup label="Administration">
                <mat-option
                  *ngFor="let f of allPossibleFields.slice(10, 17)"
                  [value]="f"
                  [disabled]="getAdvancedFieldByKey(f.key)"
                >
                  {{ f.label }}
                </mat-option>
              </mat-optgroup>

              <mat-optgroup label="Literature Info">
                <mat-option
                  *ngFor="let f of allPossibleFields.slice(17, 21)"
                  [value]="f"
                  [disabled]="getAdvancedFieldByKey(f.key)"
                >
                  {{ f.label }}
                </mat-option>
              </mat-optgroup>

              <mat-optgroup label="Governance">
                <mat-option
                  *ngFor="let f of allPossibleFields.slice(21, 27)"
                  [value]="f"
                  [disabled]="getAdvancedFieldByKey(f.key)"
                >
                  {{ f.label }}
                </mat-option>
              </mat-optgroup>

              <mat-optgroup label="Device Info">
                <mat-option
                  *ngFor="let f of allPossibleFields.slice(27)"
                  [value]="f"
                  [disabled]="getAdvancedFieldByKey(f.key)"
                >
                  {{ f.label }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>

          <!-- Dynamic Form Fields -->
          <form
            [formGroup]="advancedForm"
            style="display: flex; flex-direction: column; gap: 0.5rem"
          >
            <ng-container *ngFor="let cfg of advancedSchema; let i = index">
              <div style="display: flex; align-items: center; gap: 0.5rem">
                <ng-container [ngSwitch]="cfg.type">
                  <!-- Text -->
                  <mat-form-field
                    *ngSwitchCase="'text'"
                    appearance="outline"
                    class="full-width"
                  >
                    <mat-label>{{ cfg.label }}</mat-label>
                    <input matInput [formControlName]="cfg.key" />
                  </mat-form-field>

                  <!-- Select -->
                  <mat-form-field
                    *ngSwitchCase="'select'"
                    appearance="outline"
                    class="full-width"
                  >
                    <mat-label>{{ cfg.label }}</mat-label>
                    <mat-select [formControlName]="cfg.key">
                      <mat-option *ngFor="let o of cfg.options" [value]="o">
                        {{ o }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Date -->
                  <mat-form-field
                    *ngSwitchCase="'date'"
                    appearance="outline"
                    class="full-width"
                  >
                    <mat-label>{{ cfg.label }}</mat-label>
                    <input
                      matInput
                      [matDatepicker]="dp"
                      [formControlName]="cfg.key"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dp"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                  </mat-form-field>
                </ng-container>

                <!-- Remove button -->
                <button
                  mat-icon-button
                  color="warn"
                  (click)="removeAdvancedField(cfg.key)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </ng-container>
          </form>

          <div
            *ngIf="advancedFilters.length > 0"
            style="
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              margin-top: 1rem;
            "
          >
            <div
              *ngFor="let field of advancedSchema"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                background-color: #f1f1f1;
                padding: 6px 12px;
                border-radius: 12px;
                min-height: 32px;
                gap: 1rem;
                flex-wrap: nowrap;
              "
            >
              <div
                style="font-size: 13px; display: flex; flex-direction: column"
              >
                <strong>{{ field.label }}:</strong>
                <ng-container
                  *ngIf="
                    isArray(advancedForm.get(field.key)?.value);
                    else singleValue
                  "
                >
                  <span style="white-space: pre-wrap; word-break: break-word">
                    {{ advancedForm.get(field.key)?.value?.join(", ") }}
                  </span>
                </ng-container>
                <ng-template #singleValue>
                  <span style="white-space: pre-wrap; word-break: break-word">
                    {{ advancedForm.get(field.key)?.value }}
                  </span>
                </ng-template>
              </div>
              <button
                mat-icon-button
                color="warn"
                (click)="removeAdvancedField(field.key)"
                style="height: 24px; width: 24px; min-width: 24px"
              >
                <mat-icon style="font-size: 18px">close</mat-icon>
              </button>
            </div>
          </div>

          <!-- No filters message -->
          <div
            *ngIf="advancedSchema.length === 0"
            style="font-size: 12px; color: #888; padding-top: 0.5rem"
          >
            No filters applied.
          </div>
        </div>

        <!-- Sticky Action Buttons (Equal Width, Row Layout) -->
        <div
          style="
            position: sticky;
            bottom: 0;
            background: white;
            padding: 1rem 0 0 0;
            z-index: 10;
            border-top: 1px solid #eee;
          "
        >
          <div style="display: flex; gap: 1rem; width: 100%">
            <button
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              [disabled]="advancedSchema.length === 0"
              style="flex: 1; font-size: 13px; padding: 6px 12px"
              (click)="applyAdvancedFilters()"
            >
              Apply Advanced
            </button>

            <button
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="flex: 1; font-size: 13px; padding: 6px 12px"
              (click)="clearAllAdvancedFilters()"
            >
              Clear All
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </div>

    <!-- 6px‑wide invisible drag handle at the right edge -->
    <div
      class="sidebar-resizer-handle"
      (mousedown)="startResize($event)"
      title="Drag to resize"
    ></div>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content
    class="main-panel"
    [style.margin-left.px]="isSidenavOpen ? sidenavWidth : 0"
  >
    <div class="scroll-wrapper">
      <!-- Top Navigation Bar -->

      <mat-toolbar
        class="top-nav clean-nav"
        [style.background-color]="backgroundColorButton"
        style="padding: 0 8px"
      >
        <!-- ← left scroll arrow -->
        <button
          mat-icon-button
          class="scroll-arrow"
          *ngIf="showTopLeftArrow"
          (click)="scrollTopToolbar('left')"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>

        <div
          class="toolbar-scrollTOP"
          #topToolbarScroll
          (scroll)="onTopScroll()"
        >
          <!-- 🟩 Submenu Active View (← Configuration) -->
          <div
            class="nav-item submenu-active"
            *ngIf="currentSubmenu; else mainTopNav"
          >
            <button
              mat-icon-button
              (click)="goBackToMainMenu()"
              matTooltip="Back"
            >
              <mat-icon>arrow_back</mat-icon>
            </button>
            <mat-icon>{{ currentSubmenu.icon }}</mat-icon>
            <span>{{ currentSubmenu.label }}</span>
          </div>

          <!-- 🟨 Default Top-Level Menus -->
          <ng-template #mainTopNav>
            <!-- Dashboard -->
            <div
              mat-button
              class="nav-item"
              [ngClass]="{ active: currentSection === 'Dashboard-info' }"
              (click)="handleNavClick(Dashboard)"
            >
              <mat-icon>dashboard_customize</mat-icon>
              <span>Dashboard</span>
            </div>

            <!-- SEARCH -->
            <div
              mat-button
              class="nav-item"
              [ngClass]="{ active: currentSection === 'search-info' }"
              (click)="openSearch()"
            >
              <mat-icon>search</mat-icon>
              <span>Search</span>
            </div>

            <!-- CONFIGURATION  -->
            <div
              mat-button
              class="nav-item"
              [ngClass]="{ active: currentGroup === 'Configuration' }"
              (click)="handleNavClick(configurationItem, 'Configuration')"
            >
              <mat-icon>settings</mat-icon>
              <span>Configuration</span>
            </div>

            <!-- ADMINISTRATION dropdown -->
            <div
              class="nav-item menu-trigger"
              [matMenuTriggerFor]="adminMenu"
              aria-haspopup="true"
            >
              <mat-icon>manage_accounts</mat-icon>
              <span>Administration</span>
              <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
            </div>
            <mat-menu #adminMenu="matMenu" class="vertical-menu">
              <button
                mat-menu-item
                *ngFor="let item of adminItems"
                (click)="handleNavClick(item, 'Administration')"
              >
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
              </button>
            </mat-menu>

            <!-- DICTIONARY dropdown -->
            <div
              class="nav-item menu-trigger"
              [matMenuTriggerFor]="dictMenu"
              aria-haspopup="true"
            >
              <mat-icon>find_in_page</mat-icon>
              <span>Dictionary</span>
              <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
            </div>
            <mat-menu #dictMenu="matMenu" class="vertical-menu">
              <button
                mat-menu-item
                *ngFor="let item of dictItems"
                (click)="handleNavClick(item, 'Dictionary')"
              >
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
              </button>
            </mat-menu>

            <!-- SIGNAL ANALYTICS dropdown -->
            <div
              class="nav-item menu-trigger"
              [matMenuTriggerFor]="signalMenu"
              aria-haspopup="true"
            >
              <mat-icon>analytics</mat-icon>
              <span> Report & Analytics</span>
              <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
            </div>
            <mat-menu #signalMenu="matMenu" class="vertical-menu">
              <button
                mat-menu-item
                *ngFor="let item of signalItems"
                (click)="handleNavClick(item, 'Signal Analytics')"
              >
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
              </button>
            </mat-menu>
          </ng-template>
        </div>

        <!-- → right scroll arrow -->
        <button
          mat-icon-button
          class="scroll-arrow"
          *ngIf="showTopRightArrow"
          (click)="scrollTopToolbar('right')"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </mat-toolbar>

      <!-- startegy menus -->
      <!-- startegy menus -->
      <mat-menu #strategyMenu="matMenu" class="strategy-menu">
        <ng-container *ngIf="currentStrategyParent; else parentMenuList">
          <button mat-menu-item disabled>
            {{ currentStrategyParent.label }}
          </button>
          <button mat-menu-item (click)="backToParentList($event)">
            <mat-icon>arrow_back</mat-icon> Back
          </button>
          <ng-container *ngFor="let child of currentStrategyParent.children">
            <button mat-menu-item (click)="onSelectStrategyTemplate(child.id)">
              {{ child.label }}
            </button>
          </ng-container>
        </ng-container>

        <ng-template #parentMenuList>
          <ng-container *ngFor="let t of strategyTemplates">
            <button mat-menu-item (click)="onStrategyParentClick(t, $event)">
              {{ t.label }}
              <mat-icon
                *ngIf="t.children?.length"
                style="margin-left: auto; visibility: visible; overflow-x: auto"
                >chevron_right</mat-icon
              >
            </button>
          </ng-container>
        </ng-template>
      </mat-menu>

      <!-- Below Navigation Bar -->
      <mat-toolbar
        class="top-nav clean-nav"
        [style.background-color]="backgroundColorButton"
        style="border-top: 1px solid #111111a8; padding: 0 8px"
      >
        <!-- Left Arrow -->
        <button
          mat-icon-button
          class="scroll-arrow"
          *ngIf="showLeftArrow"
          (click)="scrollToolbar('left')"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>

        <!-- Scrollable Toolbar Items -->
        <div class="toolbar-scroll" #toolbarScroll (scroll)="onScroll()">
          <ng-container *ngFor="let item of toolbarItems">
            <!-- 🍀 SPECIAL CASE: Product Safety Strategy -->
            <ng-container
              *ngIf="
                item.section === 'Product Safety Strategy';
                else normalButton
              "
            >
              <button
                mat-button
                class="nav-item"
                [ngClass]="{ active: currentSection === item.section }"
                (click)="handleNavClick(item)"
              >
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
              </button>
            </ng-container>

            <!-- 🔹 All other buttons stay the same -->
            <ng-template #normalButton>
              <button
                mat-button
                class="nav-item"
                [ngClass]="{ active: currentSection === item.section }"
                (click)="handleNavClick(item)"
              >
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
              </button>
            </ng-template>
          </ng-container>
        </div>

        <!-- Right Arrow -->
        <button
          mat-icon-button
          class="scroll-arrow"
          *ngIf="showRightArrow"
          (click)="scrollToolbar('right')"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </mat-toolbar>

      <!-- Product Header -->
      <ng-container *ngIf="showProductHeader">
        <div class="product-header-wrapper">
          <!-- Top row: avatar, name + badge, dates, strategy title + link -->
          <div class="product-header-main">
            <!-- Left block: avatar + name/status -->
            <div class="product-id-block">
              <div class="product-avatar">
                {{ computeInitials(selectedProduct?.name) }}
                <!-- e.g. "PB" -->
              </div>
              <div class="product-meta">
                <div class="product-title-status">
                  <span class="product-title">{{ selectedProduct?.name }}</span>
                  <span
                    class="product-badge"
                    [ngClass]="{
                      'status-approved': productMeta?.status === 'Approved',
                      'status-preapproved':
                        productMeta?.status === 'Pre‑Approved',
                      'status-withdrawn': productMeta?.status === 'Withdrawn',
                      'status-terminated': productMeta?.status === 'Terminated',
                      'status-divested': productMeta?.status === 'Divested',
                      'status-investigational':
                        productMeta?.status === 'Investigational'
                    }"
                    >{{ productMeta?.status }}</span
                  >
                </div>
                <div class="product-dates">
                  <span class="product-date-label">DIBD:</span>
                  <span class="product-date-value">{{
                    productMeta?.dibd
                  }}</span>
                  <span class="date-separator">|</span>
                  <span class="product-date-label">IBD:</span>
                  <span class="product-date-value">{{ productMeta?.ibd }}</span>
                </div>
              </div>
            </div>

            <!-- Right block: safety strategy title + link -->
            <div class="product-strategy-block">
              <h3 class="strategy-title">{{ productMeta?.safetyTitle }}</h3>
              <a
                class="strategy-link"
                [href]="productMeta?.safetyStrategyLink"
                target="_blank"
                rel="noopener"
              >
                <mat-icon aria-label="Open Link">open_in_new</mat-icon>
              </a>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Container Screens    -->

      <div class="parent-wrapper">
        <div class="embedded-container">
          <!-- add new screen here <app-dummy *ngIf="currentSection === 'other-screen'"></app-dummy> -->

          <app-jsignal *ngIf="currentSection === 'jsignal'"></app-jsignal>
          <!-- PRODUCT INFO SECTION -->
          <app-product-info
            *ngIf="currentSection === 'product-info'"
          ></app-product-info>

          <!-- SEARCH  SECTION -->
          <div
            *ngIf="currentSection === 'search-info'"
            class="search-overlay"
            style="padding: 1rem"
          >
            <h3 style="margin-bottom: 1rem">Search Filters</h3>

            <form
              [formGroup]="searchForm"
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1rem;
                max-width: 800px;
              "
            >
              <!-- Dynamic form fields -->
              <ng-container *ngFor="let field of schema; trackBy: trackByKey">
                <ng-container [ngSwitch]="field.type">
                  <!-- Text Input -->
                  <mat-form-field *ngSwitchCase="'text'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput [formControlName]="field.key" />
                  </mat-form-field>

                  <!-- Select -->
                  <mat-form-field *ngSwitchCase="'select'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-select [formControlName]="field.key">
                      <mat-option
                        *ngFor="let opt of field.options"
                        [value]="opt"
                        >{{ opt }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>

                  <!-- Multiselect -->
                  <mat-form-field
                    *ngSwitchCase="'multiselect'"
                    appearance="outline"
                  >
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-select multiple [formControlName]="field.key">
                      <mat-option
                        *ngFor="let opt of field.options"
                        [value]="opt"
                        >{{ opt }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>

                  <!-- Date -->

                  <mat-form-field *ngSwitchCase="'date'" appearance="outline">
                    <mat-label>{{ field.label }}</mat-label>

                    <input
                      matInput
                      [formControlName]="field.key"
                      [matDatepicker]="picker"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </ng-container>
              </ng-container>
            </form>

            <!-- Buttons -->
            <div style="margin-top: 1rem; display: flex; gap: 1rem">
              <button
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="backgroundColorButton"
                (click)="applyFilters()"
              >
                Apply Filters
              </button>
              <button
                style="width: 70px; margin-left: 10px"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="backgroundColorButton"
                title="Cancel"
                (click)="closeSearch()"
              >
                Cancel
              </button>
            </div>
          </div>

          <app-product-safety-strategy
            *ngIf="currentSection === 'Product Safety Strategy'"
          ></app-product-safety-strategy>
          <app-create-template
            *ngIf="currentSection === 'Product Safety Strategy Template'"
          >
          </app-create-template>
          <app-review-approve *ngIf="currentSection === 'Review & Approve'">
          </app-review-approve>
          <app-review-activities *ngIf="currentSection === 'review-info'">
          </app-review-activities>
          <app-meddra-browser *ngIf="currentSection === 'MedDRA-info'">
          </app-meddra-browser>

          <!-- USER MANAGEMENT SECTION -->
          <div class="content" *ngIf="currentSection === 'user-management'">
            <h3>User Account Information</h3>
            <div class="form-grid">
              <mat-label>User ID:</mat-label>
              <input matInput value="SM_USER_1234" readonly />

              <mat-label>User Name:</mat-label>
              <input matInput value="Company Specific User Name" readonly />

              <mat-label>First Name:</mat-label>
              <input matInput value="Jon" readonly />

              <mat-label>Last Name:</mat-label>
              <input matInput value="Smith" readonly />

              <mat-label>Email ID:</mat-label>
              <input matInput value="abc@xyz.com" readonly />

              <mat-label>Roles:</mat-label>
              <mat-form-field appearance="fill">
                <mat-select multiple>
                  <mat-option selected>Admin</mat-option>
                  <mat-option>User</mat-option>
                  <mat-option>Manager</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Add remaining user info fields similarly -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
